// extracted by mini-css-extract-plugin
export default {"root":"scrollBar_root__4w+zg"};